import React from "react";
const LOG = false;

const MainContext = React.createContext();
let initialConfig = {
  navButtons: [],
  error: null,
  currentPost: {
    htmlContent: null,
    mdContent: null,
    title: null,
    id: null,
  },
  editorType: window.localStorage.getItem("hub-editor-type") || "TRIX",
  tags: null,
  tagNames: null,
  tagMap: null,
  tagIdMap: null,
  user: {
    editorType: 'TRIX'
  }
};

const mainReducer = (state, configAction) => {
  LOG && console.log("configAction");
  LOG && console.log(configAction);
  switch (configAction.type) {
    case "MAIN_SET_ERROR":
      return { ...state, error: configAction.error };
    case "MAIN_SET_NAV_BUTTONS":
      return {
        ...state,
        navButtons: configAction.navButtons,
      };
    case "MAIN_SET_CURRENT_POST":
      return {
        ...state,
        currentPost: configAction.currentPost,
      };
    case "MAIN_UPDATE_CURRENT_POST":
      return {
        ...state,
        currentPost: { ...state.currentPost, ...configAction.currentPost },
      };
    case "MAIN_UPDATE_TAGS":
      return {
        ...state,
        tags: [...(state.tags || []), ...configAction.tags],
      };
    case "MAIN_SET_TAGS":
      return {
        ...state,
        tags: configAction.tags,
      };
    case "MAIN_SET_TAG_NAMES":
      return {
        ...state,
        tagNames: configAction.tagNames,
      };
    case "MAIN_SET_TAG_MAP":
      return {
        ...state,
        tagMap: configAction.tagMap,
      };
    case "MAIN_SET_TAG_ID_MAP":
      return {
        ...state,
        tagIdMap: configAction.tagIdMap,
      };
    case "MAIN_SET_USER":
      window.localStorage.setItem("hub-editor-type", configAction.user.editorType);
      return {
        ...state,
        user: configAction.user,
      };
    default:
      return initialConfig;
  }
};

export { MainContext, mainReducer };
